import React from 'react';
import { TipsMapType } from '../index';
import { CONTACT_EMAIL } from '@op/constants';

export const engagementTipsText: TipsMapType = {
  en: 'Engagement: Summary of Likes, Comments and  Shares of Reviews.',
  zh: '互动量：主贴/评论的点赞量、评论量、转发量的汇总。',
};

export const reviewTypeTipsText: TipsMapType = {
  en: 'After selecting keywords or topics, filtering for posts is currently not supported.',
  zh: '选中关键词或话题后，暂不支持筛选主贴',
};

export const highPriorityGameTipsText: TipsMapType = {
  en: (
    <>
      There is a delay in data updating, so the data on this page (such as
      views, interactions, likes, shares, comments, followers, etc.) are not
      realtime data.
      <br />
      <br />
      Update frequency: <br />
      Starting from the day the main post or comment is published, update the
      like and comment counts (excluding sub-comments) once daily for 8
      consecutive days, then update again on day 15 and day 31, after which
      updates will stop.
    </>
  ),
  zh: (
    <>
      数据更新存在延时，所以本页数据（例如观看、互动量、点赞、分享、评论、关注等）非实时数据。
      <br />
      <br />
      更新频率： <br />
      从主贴或评论发布的当天起，连续8天每天更新一次点赞和评论数（不含评论子回复），第15天和第31天各更新一次后停止更新。
    </>
  ),
};

export const highPriorityPCTipsText: TipsMapType = {
  en: (
    <>
      Update frequency: <br />
      For Steam reviews, starting from the day the review is posted, update the
      engagement metrics (funny、helpful and likes etc.) once daily for 8
      consecutive days, then update again on day 15 and day 31, after which
      updates will stop.
    </>
  ),
  zh: (
    <>
      更新频率： <br />
      针对Steam评论，从评论发布的当天起，连续8天每天更新一次互动指标（如funny、helpful和likes等），第15天和第31天各更新一次后停止更新。
    </>
  ),
};

export const NLPAnalyseTipsText: TipsMapType = {
  en: 'For YouTube videos with more than 50 likes and accessible subtitles, use the sentiment tendency of the video title and subtitle content to adjust the sentiment score.',
  zh: '针对点赞数超过50且可获取字幕的YouTube视频，利用视频标题和字幕内容的情感倾向，进行情感分的修正。',
};

export const chzzkLiveBroadcastViewsTipsText: TipsMapType = {
  en: 'This indicator is only applicable to the Chzzk channel.',
  zh: '该指标只针对Chzzk渠道适用。',
};



export const normalTranslateTipsText: TipsMapType = {
  en: `The current game has low priority, and the original content is only available in English. For any questions, please contact ${CONTACT_EMAIL}.`,
  zh: `当前游戏优先级较低，原文仅支持英文翻译，如有疑问请联系${CONTACT_EMAIL}。`,
};

export const feedsImage: TipsMapType = {
  en: `Posts with images and text display a list of images, while video posts display the video cover.`,
  zh: `图文帖展示帖子图片列表，视频帖展示视频封面`
};